import React from "react";

type SidebarKey = "myproject" | "progress" | "team" | "documents";

type Props = {
  active: SidebarKey;
};

const baseLinkClass =
  "block w-full text-left px-4 py-2 rounded-lg text-sm";

const activeClasses = "bg-green-100 text-green-700 font-medium";
const inactiveClasses = "hover:bg-gray-100 text-gray-700";

export default function ClientSidebarLinks({ active }: Props) {
  const getClass = (key: SidebarKey) =>
    `${baseLinkClass} ${active === key ? activeClasses : inactiveClasses}`;

  return (
    <>
      <a href="#client-myproject" className={getClass("myproject")}>
        My Project
      </a>
      <a href="#client-progress" className={getClass("progress")}>
        Progress
      </a>
      <a href="#client-team" className={getClass("team")}>
        Team
      </a>
      <a href="#client-documents" className={getClass("documents")}>
        Documents
      </a>
    </>
  );
}

